var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaxSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.999,
    height: 32.999,
    viewBox: "0 0 32.999 32.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BTWInstellingen",
    transform: "translate(-4 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M7.5,32.874,32.874,7.5",
    transform: "translate(0.312 0.312)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M16.875,11.437A5.437,5.437,0,1,1,11.437,6,5.437,5.437,0,0,1,16.875,11.437Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M31.875,26.437A5.437,5.437,0,1,1,26.437,21,5.437,5.437,0,0,1,31.875,26.437Z",
    transform: "translate(3.124 3.124)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxSettings);
export default __webpack_public_path__ + "static/media/TaxSettings.32dfef6a1bd3e15ff59ac69c997aa178.svg";
export { ForwardRef as ReactComponent };